const excelColumns = [
  { id: 'rowIndex', color: '#000000' },
  { id: 'email', color: '#000000' },
  { id: 'validationError', color: 'red' }
];

export { excelColumns };
